import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Alert } from 'react-bootstrap';
import { GET_ALL_OPERATER_USERS, GetAllRoles } from '../../URLs/Apis';
import "./Operation.css";
import def from "../../assets/images/default.png";
import { useNavigate } from 'react-router-dom';
import FilterBy from "../../components/FillterBy";
import Addmember from "../../components/Addmember";
import { useSelector } from "react-redux";

const Operation = () => {
  const { user } = useSelector((state) => state.auth);

  const [agents, setAgents] = useState([]); 
  const [filteredAgents, setFilteredAgents] = useState([]); 
  const [errors, setErrors] = useState('');
  const [loading, setLoading] = useState(true);
  const [submitMessage, setSubmitMessage] = useState({ type: '', text: '' });
  const [formalRoles, setFormalRoles] = useState([]); 

  const navigate = useNavigate();

  const [showAddMemberModal, setShowAddMemberModal] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedJobTitles, setSelectedJobTitles] = useState([]);
  const [filterJoinDate, setFilterJoinDate] = useState(''); 

  const [isSearching, setIsSearching] = useState(false); 
  const [searchQuery, setSearchQuery] = useState(''); 


  const getStaffData = useCallback(() => {
    setLoading(true);
    setErrors('');

    // const token = `1|uXWWHVAxUbLR94IuQ07nZUT5306vlnjfGFo4AUoR16bcf002`;
    const token = user?.token;
    if (!token) {
        setErrors('Authentication token is missing.');
        setLoading(false);
        setAgents([]); 
        return;
    }

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    axios
      .get(GET_ALL_OPERATER_USERS, { headers })
      .then((response) => {
        console.log("Fetched operators:", response.data.data.operators);
        setAgents(response.data.data.operators || []); 
        setErrors('');
      })
      .catch((error) => {
        console.error('Fetch error:', error);
        setErrors(error.response?.data?.message || error.message || 'Failed to fetch operators.');
        setAgents([]); 
      })
      .finally(() => {
         setLoading(false);
      });
  }, [user?.token]); 


  const getFormalRoles = useCallback(() => {
    const token = user?.token;
    if (!token) {
         console.warn("Authentication token not available for fetching formal roles.");
        setFormalRoles([]);
        return;
    }
     const headers = { Authorization: `Bearer ${token}` };
     axios.get(GetAllRoles, { headers })
        .then(response => {
             console.log("Fetched formal roles for filtering:", response.data.data.categories);
            setFormalRoles(response.data.data.categories || []);
        })
        .catch(error => {
            console.error("Error fetching formal roles:", error.response?.data || error.message);
            setFormalRoles([]);
        });
  }, [user?.token]);



  useEffect(() => {
    getStaffData();
    getFormalRoles(); 
  }, [getStaffData, getFormalRoles]); 


  useEffect(() => {
      console.log("Applying filters:", { selectedJobTitles, filterJoinDate, searchQuery, isSearching });

      const applyFilters = () => {
          let tempAgents = [...agents]; 
          const lowerCaseQuery = searchQuery.toLowerCase(); 


          if (selectedJobTitles && selectedJobTitles.length > 0) {
              tempAgents = tempAgents.filter(agent => {
                   const agentRoleName = agent.roles?.[0]?.name; 

                   
                   const isActualAgent = !agentRoleName || !formalRoles.includes(agentRoleName);

                   return selectedJobTitles.some(selectedTitle => {
                       if (selectedTitle.toLowerCase() === 'agent') { // Compare lowercase
                           return isActualAgent;
                       } else {
                          
                           return agentRoleName && agentRoleName.toLowerCase() === selectedTitle.toLowerCase();
                       }
                   });
              });
          }

      
          if (filterJoinDate) {
             tempAgents = tempAgents.filter(agent => {
                 if (!agent.created_at) return false;
               
                 const agentJoinDatePart = agent.created_at.split(' ')[0].split('T')[0];
                 return agentJoinDatePart === filterJoinDate;
             });
          }

       
          if (lowerCaseQuery) {
              tempAgents = tempAgents.filter(agent => {
              
                  const nameMatch = agent.name?.toLowerCase().includes(lowerCaseQuery);
                  const emailMatch = agent.email?.toLowerCase().includes(lowerCaseQuery);
                  const usernameMatch = agent.username?.toLowerCase().includes(lowerCaseQuery);
                  const phoneMatch = agent.phone_number?.includes(searchQuery); 
           
                  const idMatch = agent.id?.toString().includes(searchQuery); 

                  return nameMatch || emailMatch || usernameMatch || phoneMatch || idMatch;
              });
          }
            console.log(tempAgents);
            
          setFilteredAgents(tempAgents);
      };

    
      applyFilters();

  }, [agents, selectedJobTitles, filterJoinDate, formalRoles, searchQuery]); 

  const handleCardClick = (agent) => {
    navigate(`/operation/${agent.id}`);
  };

  const handleShowAddMemberModal = () => {
    setSubmitMessage({ type: '', text: '' });
    setShowAddMemberModal(true);
  };

  const handleCloseAddMemberModal = () => {
    setShowAddMemberModal(false);
  };

  const handleAddMemberSuccess = () => {
    getStaffData(); 
    setSubmitMessage({ type: 'success', text: 'New operator added successfully!' });
  };

  const handleToggleFilterDrawer = (openState) => {
    setIsFilterOpen(openState);
  };

  const handleJobTitleChange = (title) => {
      setSelectedJobTitles(prev => {
          const newState = prev.includes(title) ? prev.filter(t => t !== title) : [...prev, title];
      
          return newState;
      });
  };

  const handleSearchClick = () => {
      setIsSearching(true);
      
  };

  const handleCloseSearchClick = () => {
      setIsSearching(false); 
      setSearchQuery(''); 
  };

  if (loading) {
    return <div className="container my-4">Loading operators...</div>;
  }

  return (
    <div className="m-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h5>Operation</h5>
        {/* Conditional rendering based on isSearching state */}
        {isSearching ? (
          <div className="d-flex flex-grow-1 align-items-center gap-2 ms-3">
            <input
              id="searchInput"
              type="text"
              className="form-control rounded-pill shadow-sm border-0 flex-grow-1"
              placeholder="Search by name, email, username, phone..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{ height: "48px", backgroundColor: "#f8f8f8" }}
              autoFocus
            />
            {/* Close Search Button */}
            <button
              className="btn btn-light border rounded-circle shadow-sm d-flex align-items-center justify-content-center"
              style={{ width: "48px", height: "48px", padding: 0 }}
              aria-label="Close Search"
              onClick={handleCloseSearchClick}
            >
              {/* Bootstrap Close Icon */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-x-lg"
                viewBox="0 0 16 16"
              >
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
              </svg>
            </button>
          </div>
        ) : (
          <div className="d-flex gap-2">
            {/* Search Button - now calls handleSearchClick */}
            <button
              className="btn btn-light border rounded-4 shadow-sm d-flex align-items-center justify-content-center"
              style={{ width: "48px", height: "48px", padding: 0 }}
              aria-label="Search"
              onClick={handleSearchClick}
            >
              {/* Search icon */}
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
            </button>

            {/* Filter Button */}
            <button
              className="btn btn-light border rounded-4 shadow-sm d-flex align-items-center justify-content-center"
              style={{ width: "48px", height: "48px", padding: 0 }}
              aria-label="Filter"
              onClick={() => handleToggleFilterDrawer(true)}
              aria-expanded={isFilterOpen}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="4" y1="8" x2="20" y2="8"></line>
                <circle cx="16" cy="8" r="2"></circle>
                <line x1="4" y1="16" x2="20" y2="16"></line>
                <circle cx="8" cy="16" r="2"></circle>
              </svg>
            </button>

            {/* Add Member Button */}
            <button
              className="btn btn-light border rounded-4 shadow-sm d-flex align-items-center gap-2 px-3"
              onClick={handleShowAddMemberModal}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-plus"
                viewBox="0 0 16 16"
              >
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
              </svg>
              Add Member
            </button>
          </div>
        )}
      </div>

      {/* The FilterBy component */}
      <FilterBy
        open={isFilterOpen}
        toggleDrawer={handleToggleFilterDrawer}
        selectedJobTitles={selectedJobTitles}
        setselectedJobTitles={setSelectedJobTitles}
        handleJobTitleChange={handleJobTitleChange}
        filteredStaff={filteredAgents.length}
        joinDate={filterJoinDate}
        setjoinDate={setFilterJoinDate}
        formalRoles={formalRoles}
      />

      {/* Display general errors or submission messages */}
      {errors && <div className="alert alert-danger">{errors}</div>}
      {submitMessage.text && (
        <Alert
          variant={submitMessage.type}
          onClose={() => setSubmitMessage({ type: "", text: "" })}
          dismissible
        >
          {submitMessage.text}
        </Alert>
      )}

      <div className="row">
        {/* Map and render filteredAgents */}
        {filteredAgents.length > 0 ? (
          filteredAgents.map((agent, idx) => (
            <div className="col-md-4 mb-4" key={agent.id || idx}>
              <div
                className="card shadow-sm border-0 rounded-4 p-3"
                style={{ cursor: "pointer" }}
                onClick={() => handleCardClick(agent)}
              >
                <div className="card-body text-center position-relative">
                  <div className='text-start'>
                    <span className="badge rounded-pill bg-dark px-3 py-2">
                      {agent.roles?.[0] || "Agent"}
                    </span>
                  </div>
                  <img
                    src={agent.profile_photo_url || def}
                    alt={agent.name}
                    onError={(e) => {
                      e.target.onerror = null; 
                      e.target.src = def; 
                    }}
                    className="rounded-circle my-2"
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                    }}
                  />
                  <h6 className="fw-bold mb-3">{agent.name}</h6>
                  <div className="text-start small px-2">
                    {agent.reference != null && (
                      <p className="d-flex justify-content-between mb-2">
                        <span className="text-muted">Reference Number</span>
                        <span>{agent.reference}</span>
                      </p>
                    )}
                    <p className="d-flex justify-content-between mb-2">
                      <span className="text-muted">Mobile Number</span>
                      <span>{agent.phone_number || "-"}</span>
                    </p>
                    <p className="d-flex justify-content-between mb-2">
                      <span className="text-muted">Birth date</span>
                      <span>{agent.birthdate || "-"}</span>
                    </p>
                    <p className="d-flex justify-content-between mb-2">
                      <span className="text-muted">Join on</span>
                      <span>{agent.joined_at || "-"}</span>
                    </p>
                    <p className="d-flex justify-content-between mb-2">
                      <span className="text-muted">Gender</span>
                      <span>{agent.gender || "-"}</span>
                    </p>
                    <p className="d-flex justify-content-between mb-2">
                      <span className="text-muted">Username</span>
                      <span>{agent.username || "-"}</span>
                    </p>
                    <p className="d-flex justify-content-between mb-0">
                      <span className="text-muted">Email</span>
                      <span className="text-dark fw-semibold">
                        {agent.email || "-"}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : !loading &&
          errors === "" &&
          searchQuery === "" &&
          selectedJobTitles.length === 0 &&
          !filterJoinDate ? (
          <div className="col-12 text-center">No operators available.</div>
        ) : !loading && errors === "" ? (
          <div className="col-12 text-center">
            No operators found matching the criteria.
          </div>
        ) : null}
      </div>

      {/* Render the Addmember component */}
      <Addmember
        show={showAddMemberModal}
        onHide={handleCloseAddMemberModal}
        onSubmitSuccess={handleAddMemberSuccess}
        memberData={null}
      />
    </div>
  );
};

export default Operation;